/* eslint-disable react/no-unknown-property */
import React, { useEffect, useMemo, useState } from "react"
import Compressor from "compressorjs"
import {
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  Container,
  FormGroup,
  FormFeedback,
  UncontrolledTooltip,
  Toast,
  ToastHeader,
  ToastBody,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import { useFormik } from "formik"
import * as Yup from "yup"
import Dropzone from "react-dropzone"
import { useNavigate } from "react-router-dom"
import uploadImage from "../../../../assets/images/uploadImage.png"
import toast from "react-hot-toast"
import useApi from "common/ApiMiddlewere"
import { flatMap } from "lodash"
import Loader from "common/Loader"
import { useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import breadcrumbs from "common/Breadcrumbs"
import Breadcrumb from "components/Common/Breadcrumb"
import { routes } from "routes/path"

let categories = []
function CreateUpdateManufactureProduct() {
  document.title = `Manufacture Product | ${localStorage.getItem("ShopName")}`
  const { getApi, postApi, putApi } = useApi()
  const { state } = useLocation()
  const navigate = useNavigate()
  let { pathname } = useLocation()
  const [screeLoad, setscreeLoad] = useState(true)
  const [tableData, setTableData] = useState([])
  const [previewUrl, setPreviewUrl] = useState(state?.data?.Image)
  const [editData, setEditData] = useState(state?.data)
  const [isEdit, setIsEdit] = useState(state?.data || false)
  const [formSumitLoading, setformSumitLoading] = useState(false)
  const [isInStock, setIsInStock] = useState(true)
  const [modal, setModal] = useState(false)
  const [formSumitLoading1, setformSumitLoading1] = useState(false)
  const [branches, setBranches] = useState([])
  const [branchUserId, setBranchUserId] = useState(0)

  useEffect(() => {
    setscreeLoad(true)
    getApi("User/user-lookup").then(({ data, status }) => {
      if (status === 200) {
        setscreeLoad(false)
        const filteredData = data.filter(item => item.Key !== 1);
        setBranches(filteredData);
      } else {
        setscreeLoad(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }, [])

  // toggle handlers
  const toggle = () => {
    setModal(!modal)
  }

  const handleCancle = () => {
    toggle()
  }

  // product validation
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: "",
      Name: isEdit ? editData?.Name : '',
      remarks: isEdit ? editData?.Remarks : "",
      Category: isEdit ? editData?.categoryId : 0,
      Branch: isEdit ? editData?.BranchUserId : 0,
      Rent: isEdit ? editData?.Rent : 0,
      MRP: isEdit ? editData?.MRP : 0,
      M_Cost: isEdit ? editData?.M_Cost : 0,
      profilePic: isEdit ? editData?.Image : "",
    },
    validationSchema: Yup.object({
      Name: Yup.string().required("The Product Name is required"),
      Category: Yup.number().min(1, "The Category is required"),
      Branch: Yup.number().min(1, "The Branch is required"),
      Rent: Yup.number().min(1, "The Rent is required"),
    }),
    onSubmit: values => {
      setformSumitLoading(true)
      if (values) {
        const profilePic =
          values.profilePic !== ""
            ? values.profilePic.split(",")[1]
            : values.profilePic
        const data = {
          Id: isEdit ? editData?.Id : 0,
          branchUserId: parseInt(values.Branch),
          categoryId: parseInt(values.Category),
          name: values.Name,
          rent: parseFloat(values.Rent),
          mrp: parseFloat(values.MRP),
          M_Cost: parseFloat(values.M_Cost || 0),
          image: profilePic,
          remarks: values.remarks,
        }
        isEdit ?
          putApi("Product/manufacturing-product/update", data).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status === 200) {
              toast.success("Product Update Successfully", {
                style: {
                  fontSize: "15px",
                },
              })
              navigate(routes.manufactureProduct)
              validation.values.profilePic = ""
              setPreviewUrl("")
              validation.handleReset()
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
          })
          :
          postApi("Product/manufacturing-product/create", data).then(({ data, status }) => {
            setformSumitLoading(false)
            if (status === 200) {
              toast.success("Product Create Successfully", {
                style: {
                  fontSize: "15px",
                },
              })
              navigate(routes.manufactureProduct)
              validation.values.profilePic = ""
              setPreviewUrl("")
              validation.handleReset()
            } else {
              toast.error(data, {
                style: {
                  fontSize: "15px",
                },
              })
            }
          })

      }
    },
  })


  useEffect(() => {
    if (parseInt(validation.values.Branch) > 0) {
      setscreeLoad(true)
      getApi(`Category/category-lookup?userId=${parseInt(isEdit ? editData?.BranchUserId : validation.values.Branch)}`).then(({ data, status }) => {
        if (status === 200) {
          setscreeLoad(false)
          categories = data
          if (isEdit) {
            validation.setFieldValue("Category", editData?.CategoryId)
          }
        } else {
          setscreeLoad(false)
          toast.error(data, {
            style: {
              fontSize: "15px",
            },
          })
        }
      })
    }
  }, [validation.values.Branch, isEdit])


  // product image convert toBase64 string
  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = error => reject(error)
    })

  // image select handler
  const handleDrop = acceptedFiles => {
    const selectedFile = acceptedFiles[0]
    new Compressor(selectedFile, {
      quality: 0.4, // 0.6 can also be used, but its not recommended to go below.
      success: async compressedResult => {
        setPreviewUrl(URL.createObjectURL(compressedResult))
        validation.setFieldValue("profilePic", await toBase64(compressedResult))
      },
    })
  }

  const handleKeyPress = event => {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  };

  // product image handler
  const handleclick = () => {
    validation.setFieldValue("profilePic", null)
    setPreviewUrl(null)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          {screeLoad && (
            <div className="loading-overlay is-active">
              <span className="fas fa-spinner fa-3x fa-spin"></span>
            </div>
          )}
          <Breadcrumb
            parent={breadcrumbs[pathname].parent}
            breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
            parentLink={breadcrumbs[pathname].parentLink}
          />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <Form
                    className="needs-validation"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                    onReset={e => {
                      e.preventDefault()
                      validation.handleReset()
                      return false
                    }}
                  >
                    <Row>
                      <Col md="3">
                        <FormGroup>
                          <Dropzone
                            onDrop={handleDrop}
                            onClick={handleDrop}
                            accept="image/*"
                            multiple={false}
                            id="profilePic"
                            name="profilePic"
                          >
                            {({ getRootProps, getInputProps }) => (
                              <>
                                <div className="d-flex flex-column align-items-center text-center p-2 py-3">
                                  {previewUrl ? (
                                    <>
                                      <div className="position-relative overflow-hidden product-image">
                                        <input {...getInputProps()} />
                                        <img
                                          style={{
                                            cursor: "pointer",
                                            border: "1px solid #ced4da",
                                            borderRadius: "3px",
                                          }}
                                          width="175px"
                                          height="200px"
                                          src={previewUrl}
                                          {...getRootProps()}
                                        />
                                        {/* <div className="delete-button">
                                          <button
                                            className="btn btn-sm btn-danger mb-1 me-1"
                                            onClick={() => handleclick()}
                                            type="button"
                                          >
                                            <i className=" fs-6 fas fa-trash-alt"></i>
                                          </button>
                                        </div> */}
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <input {...getInputProps()} />

                                      <div
                                        style={{
                                          width: "175px",
                                          height: "200px",
                                          border: "1px solid #ced4da",
                                          cursor: "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          borderRadius: "3px",
                                        }}
                                      >
                                        <img
                                          className="img-fluid"
                                          style={{}}
                                          src={uploadImage}
                                          {...getRootProps()}
                                        />
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )}
                          </Dropzone>
                        </FormGroup>
                      </Col>
                      <Col md="9">
                        <Row>
                          <Col md="3">
                            <div className="mb-2">
                              <FormGroup className="mb-2">
                                <Label
                                  htmlFor="validationCustom02"
                                  className="required"
                                >
                                  Branch
                                </Label>
                                <Input
                                  type="select"
                                  id="validationCustom02"
                                  bsSize="sm"
                                  className="form-control-sm"
                                  name="Branch"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Branch || ""}
                                  invalid={
                                    validation.touched.Branch &&
                                      validation.errors.Branch
                                      ? true
                                      : false
                                  }
                                >
                                  <option value={0}>Select</option>
                                  {branches?.map((item, index) => {
                                    return (
                                      <option key={index} value={item.Key}>
                                        {item.Value}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {validation.touched.Branch &&
                                  validation.errors.Branch ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Branch}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </div>
                            {validation.touched.Branch &&
                              validation.errors.Branch ? (
                              <FormFeedback type="invalid">
                                {validation.errors.Branch}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col md="3">
                            <div className="mb-2">
                              <FormGroup className="mb-2">
                                <Label
                                  htmlFor="validationCustom02"
                                  className="required"
                                >
                                  Category
                                </Label>
                                <Input
                                  type="select"
                                  id="validationCustom02"
                                  bsSize="sm"
                                  className="form-control-sm"
                                  name="Category"
                                  onChange={validation.handleChange}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.Category || ""}
                                  invalid={
                                    validation.touched.Category &&
                                      validation.errors.Category
                                      ? true
                                      : false
                                  }
                                >
                                  <option value={0}>Select</option>
                                  {categories.map((item, index) => {
                                    return (
                                      <option key={index} value={item.Key}>
                                        {item.Value}
                                      </option>
                                    )
                                  })}
                                </Input>
                                {validation.touched.Category &&
                                  validation.errors.Category ? (
                                  <FormFeedback type="invalid">
                                    {validation.errors.Category}
                                  </FormFeedback>
                                ) : null}
                              </FormGroup>
                            </div>
                            {validation.touched.Category &&
                              validation.errors.Category ? (
                              <FormFeedback type="invalid">
                                {validation.errors.Category}
                              </FormFeedback>
                            ) : null}
                          </Col>
                          <Col md="6">
                            <FormGroup className="mb-2">
                              <Label
                                htmlFor="validationCustom03"
                                className="required"
                              >
                                Product Name
                              </Label>
                              <Input
                                name="Name"
                                placeholder="Product Name"
                                type="text"
                                className="form-control-sm"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.Name || ""}
                                invalid={
                                  validation.touched.Name &&
                                    validation.errors.Name
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.Name &&
                                validation.errors.Name ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.Name}
                                </FormFeedback>
                              ) : null}
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="2">
                            <div className="mb-2">
                              <Label className="form-label required">
                                Rent
                              </Label>
                              <Input
                                name="Rent"
                                className="form-control-sm"
                                placeholder="0"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                onKeyPress={handleKeyPress}
                                value={validation.values.Rent}
                                invalid={
                                  validation.touched.Rent &&
                                    validation.errors.Rent
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.Rent &&
                                validation.errors.Rent ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.Rent}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md="2">
                            <div className="mb-2">
                              <Label className="form-label ">
                                MRP
                              </Label>
                              <Input
                                name="MRP"
                                className="form-control-sm"
                                placeholder="0"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                onKeyPress={handleKeyPress}
                                value={validation.values.MRP}
                                invalid={
                                  validation.touched.MRP &&
                                    validation.errors.MRP
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.MRP &&
                                validation.errors.MRP ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.MRP}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md="2">
                            <div className="mb-2">
                              <Label className="form-label">
                                M_Cost
                              </Label>
                              <Input
                                name="M_Cost"
                                className="form-control-sm"
                                placeholder="0"
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                onKeyPress={handleKeyPress}
                                value={validation.values.M_Cost}
                                invalid={
                                  validation.touched.M_Cost &&
                                    validation.errors.M_Cost
                                    ? true
                                    : false
                                }
                              />
                              {validation.touched.M_Cost &&
                                validation.errors.M_Cost ? (
                                <FormFeedback type="invalid">
                                  {validation.errors.M_Cost}
                                </FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col md="12">
                            <FormGroup className="mb-2">
                              <Label htmlFor="validationCustom05">Remark</Label>
                              <Input
                                name="remarks"
                                rows="2"
                                placeholder="Type your remark here"
                                type="textarea"
                                className="form-control-sm"
                                value={validation.values.remarks || ""}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="12" className="text-end">
                        <Button
                          color="secondary"
                          className="btn btn-primary me-2"
                          type="reset"
                          onClick={() => { setTableData([]), navigate(routes.manufactureProduct) }}
                        >
                          Cancel
                        </Button>

                        <>
                          {formSumitLoading ? (
                            <button type="button" className="btn btn-primary ">
                              <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                              Loading
                            </button>
                          ) : (
                            <Button
                              color="primary"
                              className="btn btn-primary "
                              type="submit"
                            >
                              Submit
                            </Button>
                          )}
                        </>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default CreateUpdateManufactureProduct
